import styled from "styled-components";

export const StyledRequestChangeAddressPage = styled.div`
    .subTitle {
        margin-bottom: 10px;
        font-size: var(--size-14);
        font-weight: var(--weight-600);
        line-height: 19px;
        color: var(--color-primary);
        text-transform: uppercase;
    }

    .policyholderListAddressForm {
        margin: 20px 0 40px 0;

        label {
            margin-bottom: 8px;
            margin-top: 8px;
        }
    }
`;
